// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1dqiy","label":"Section_label__2euvk","contentWrap":"Section_contentWrap__3sUt-","footer":"Section_footer__20q4N","footerInner":"Section_footerInner__WYX3s"};